import {sendServerRequest} from './baseService';

export const searchService = {
    searchSite,
};

async function searchSite(phrase, limit = 10) {
    return sendServerRequest('GET', `/api/search?phrase=${encodeURIComponent(phrase)}&limit=${limit}`);
}
